import { useEffect } from 'react';
import { DWP_UPDATE_LOGIN_INFO } from '../comm/constant';
import { getUUID } from '.';

export const useUpdateOtherLoginInfo = () => {
  useEffect(() => {
    let channel = null;
    try {
      channel = new BroadcastChannel(DWP_UPDATE_LOGIN_INFO);

      const DWP_ID = getUUID();
      sessionStorage.setItem('DWP_ID', DWP_ID);
      // 接收消息
      channel.onmessage = function (event) {
        // 除了当前窗口，其他窗口刷新
        if (String(event.data.DWP_ID) !== String(DWP_ID)) {
          window.location.reload();
        }
      };
    } catch (error) {}

    return () => {
      if (channel) {
        channel.close();
      }
    };
  }, []);
};

export const mutationUpdateOtherLoginInfo = () => {
  try {
    const channel = new BroadcastChannel(DWP_UPDATE_LOGIN_INFO);

    channel.postMessage({ message: 'Update', DWP_ID: sessionStorage.getItem('DWP_ID') });
  } catch (error) {}
};
